import Section from './Section'
import { default as Body } from './SectionBody'

export default Object.assign(Section, {
  Body,
})
